import { render, staticRenderFns } from "./UserRefresh.vue?vue&type=template&id=37a8e737&"
import script from "./UserRefresh.vue?vue&type=script&lang=js&"
export * from "./UserRefresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports